module.exports = __webpack_public_path__ + "img/home-53-hero_16x9_jp_poster.0c85047.jpg";